// import Header from '../common/header' 
// import SideNav from '../common/sideNav' 
// import Footer from '../common/footer' 
// import imgtmbnl from '../../assets/img/news-1.jpg'
// import productimg from '../../assets/img/product-1.jpg'
import React, { useEffect, useState } from 'react';
import { getEnvUrl,getToken } from '../../utils/Api';
import Chart from 'chart.js/auto';

function Home() {
  const year =new Date().getFullYear()
  const [daySales, setDaySales] = useState(0);
  const [monthSales, setMonthSales] = useState(0);
  const [yearSales, setYearSales] = useState(0);
  const [rsData, setRsData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(getEnvUrl() + '/admin/dashboard', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getToken()
          }
        });

        if (response.ok) {
          const data = await response.json();
          if (data.status) {
            setDaySales(data.data.day_sales);
            setMonthSales(data.data.month_sales);
            setYearSales(data.data.year_sales);
            barChartRebuild(data.data.sales_by_month);
            pieChartRebuild(
              data.data.subscribers.labels,
              data.data.subscribers.values
            );
            setRsData(data.data.rs_data);
            }
        } else {
          throw new Error('Failed to fetch data');
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);
    let barchart = null;
  let piechart = null;

  const barChartRebuild = (data) => {
    if (barchart) {
      barchart.destroy();
    }
    salebarchart(data);
  };

  const pieChartRebuild = (labels, values) => {
    if (piechart) {
      piechart.destroy();
    }
    subscriptionchart(labels, values);
  };

  const salebarchart = (inputdata) => {
    barchart = new Chart(document.querySelector('#barChart'), {
      type: 'bar',
      data: {
        labels: [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dev'
        ],
        datasets: [
          {
            label: 'Bar Chart',
            data: inputdata,
            backgroundColor: [
              'rgba(255, 99, 132, 0.2)',
              'rgba(255, 159, 64, 0.2)',
              'rgba(255, 205, 86, 0.2)',
              'rgba(75, 192, 192, 0.2)',
              'rgba(54, 162, 235, 0.2)',
              'rgba(153, 102, 255, 0.2)',
              'rgba(201, 203, 207, 0.2)',
              'rgba(255, 99, 132, 0.2)',
              'rgba(255, 159, 64, 0.2)',
              'rgba(255, 205, 86, 0.2)',
              'rgba(75, 192, 192, 0.2)',
              'rgba(54, 162, 235, 0.2)',
              'rgba(153, 102, 255, 0.2)',
              'rgba(201, 203, 207, 0.2)'
            ],
            borderColor: [
              'rgb(255, 99, 132)',
              'rgb(255, 159, 64)',
              'rgb(255, 205, 86)',
              'rgb(75, 192, 192)',
              'rgb(54, 162, 235)',
              'rgb(153, 102, 255)',
              'rgb(201, 203, 207)',
              'rgb(255, 99, 132)',
              'rgb(255, 159, 64)',
              'rgb(255, 205, 86)',
              'rgb(75, 192, 192)',
              'rgb(54, 162, 235)',
              'rgb(153, 102, 255)',
              'rgb(201, 203, 207)'
            ],
            borderWidth: 1
          }
        ]
      },
      options: {
        scales: {
          y: {
            beginAtZero: true
          }
        }
      }
    });
  };

  const subscriptionchart = (labels, values) => {
    piechart = new Chart(document.querySelector('#pieChart'), {
      type: 'pie',
      data: {
        labels: labels,
        datasets: [
          {
            label: 'Subscription plan wise users count',
            data: values,
            backgroundColor: [
              'rgb(255, 99, 132)',
              'rgb(54, 162, 235)',
              'rgb(255, 205, 86)',
              'rgb(172, 59, 201)',
              'rgb(76,222,228)',
              'rgb(192,192,192)',
              'rgb(102,0,51)',
              'rgb(153,204,255)',
              'rgb(255,204,255)',
              'rgb(22,221,53)',
              'rgb(150,155,116)',
              'rgb(0,65,89)',
              'rgb(176,0,81)',
              'rgb(78,97,114)',
              'rgb(178,162,150)',
              'rgb(223,210,124)',
              'rgb(228,153,105)',
            ],
            hoverOffset: 4
          }
        ]
      }
    });
  };
  return (
    <div> 
  <main id="main" className="main">
    <div className="pagetitle">
      <h1>Dashboard</h1>
      <nav>
        <ol className="breadcrumb">
          <li className="breadcrumb-item"><a href="home">Home</a></li>
          <li className="breadcrumb-item active">Dashboard</li>
        </ol>
      </nav>
    </div> 
    <section className="section dashboard">
      <div className="row">
        <div className="col-lg-12">
          <div className="row">
            <div className="col-xxl-4 col-md-4">
              <div className="card info-card sales-card"> 
                <div className="card-body">
                  <h5 className="card-title">Sales <span>| Today</span></h5>
                  <div className="d-flex align-items-center">
                    <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                      <i className="bi bi-cart" />
                    </div>
                    <div className="ps-3">
                      <h6><i className="bi bi-currency-rupee" /><span id="today">{daySales}</span></h6>
                      </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xxl-4 col-md-4">
              <div className="card info-card revenue-card">  
                <div className="card-body">
                  <h5 className="card-title">Revenue <span>| This Month</span></h5>
                  <div className="d-flex align-items-center">
                    <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                      <i className="bi bi-currency-rupee" />
                    </div>
                    <div className="ps-3">
                      <h6><i className="bi bi-currency-rupee" /><span id="this_month">{monthSales}</span></h6>
                      </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xxl-4 col-md-4">
              <div className="card info-card revenue-card">  
                <div className="card-body">
                  <h5 className="card-title">Revenue <span>| This Year</span></h5>
                  <div className="d-flex align-items-center">
                    <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                      <i className="bi bi-currency-rupee" />
                    </div>
                    <div className="ps-3">
                      <h6><i className="bi bi-currency-rupee" /><span id="this_year">{yearSales}</span></h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-6">
                <div className="card">
                  <div className="card-body">
                    <h2 className="card-title" id="currentYear">Subscription users {year}</h2>
                    <canvas id="pieChart" style={{"max-height":"400px"}} />
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="card">
                  <div className="card-body">
                    <h5 className="card-title" id="currentYearsales">Sales {year}</h5>
                    <canvas id="barChart" style={{"max-height":"400px"}} />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="card recent-sales overflow-auto">
                <div className="filter">
                  <a className="icon" href="#" data-bs-toggle="dropdown"><i className="bi bi-three-dots" /></a>
                  <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                    <li className="dropdown-header text-start">
                      <h6>Filter</h6>
                    </li>
                    <li><a className="dropdown-item" href="#">Today</a></li>
                    <li><a className="dropdown-item" href="#">This Month</a></li>
                    <li><a className="dropdown-item" href="#">This Year</a></li>
                  </ul>
                </div>
                <div className="card-body">
                  <h5 className="card-title">Recent Subscribers </h5>
                  <table className="table  ">
                    <thead>
                      <tr>
                        <th scope="col">UserId</th>
                        <th scope="col">Subscriber</th>
                        <th scope="col">Plan</th>
                        <th scope="col">Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                    {rsData.map((row, index) => (
                      <tr key={index}>
                        <td>{row.user_id}</td>
                        <td>{row.ph_no}</td>
                        <td>{row.total_amount}</td>
                        <td>{row.plan_name}</td>
                      </tr>
                    ))}
                    </tbody>
                  </table> 
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
    </div>
  );
}

export default Home;
